
import Vue from "vue";
import VueRouter from "vue-router";
import App from "./App.vue";
import routes from "./page";

Vue.use(VueRouter);

const router = new VueRouter({
	mode: "history",
	routes: routes
});

const app = new Vue({
	router: router,
	render: h => h(App)
})
.$mount("#app-root");



// WEBPACK FOOTER //
// ./src/js/main.js